import { compose, toPairs, reduce } from 'ramda';

export const getActionsFromDucks = compose(
  reduce((acc, [name, { actions }]) => (actions ? { ...acc, [name]: actions } : acc), {}),
  toPairs
);
